/**
 * 配置编译环境和线上环境之间的切换
 */
let base = 'http://localhost:7200/account' // 账号中心
let organization = 'http://localhost:7201/organization' // 组织中心
let personalConsole = 'http://192.168.1.151/personalConsole' // 个人控制台
let enterpriseConsole = 'http://192.168.1.151/enterpriseConsole' // 企业控制台
let application = 'http://localhost:7206/application' // 应用中心
let product = 'http://localhost:8086/product' // 产品中心
let message = 'http://localhost:8086/message' // 消息中心
let user = 'http://localhost:8086/user' // 用户中心
let project = 'http://localhost:8086/project' // 项目中心
let attestation = 'http://localhost:8086/attestation' // 认证中心
let service = 'http://localhost:8086/service' // 服务中心
let cooperation = 'http://localhost:8086/cooperation' // 合作中心
let safety = 'http://localhost:7214/cooperation' // 安全中心
let organizationManage = 'http://localhost:7214/cooperation' // 组织管理
let backlog = 'http://192.168.1.224/backlog'
let home = 'http://192.168.1.224/skypegmwcn'
let cooperationMarket = 'http://192.168.1.224/cooperationMarket'
let serviceMarket = 'http://192.168.1.224/serviceMarket'
let attestationMarket = 'http://192.168.1.224/attestationMarket'
let applicationMarket = 'http://192.168.1.224/applicationMarket'

const target = process.env.NODE_ENV

if (target === 'test') {
  // base = 'http://fcctest.lingzhuyun.com/account'
  // organization = 'http://foctest.lingzhuyun.com/organization'
  // personalConsole = 'http://cpctest.lingzhuyun.com/personalConsole'
  // enterpriseConsole = 'http://cbctest.lingzhuyun.com/enterpriseConsole'
  // application = 'http://factest.lingzhuyun.com'
  // product = 'http://fpctest.lingzhuyun.com/product'
  // message = 'http://fmctest.lingzhuyun.com/message'
  // user = 'http://fuctest.lingzhuyun.com/user'
  // project = 'http://fectest.lingzhuyun.com/project'
  // attestation = 'http://acmtest.lingzhuyun.com/attestation'
  // service = 'http://fsctest.lingzhuyun.com/service'
  // cooperation = 'http://fjctest.lingzhuyun.com/cooperation'
  // safety = 'http://fbctest.lingzhuyun.com/cooperation'
  // organizationManage = 'http://aomtest.lingzhuyun.com/cooperation'
  // backlog = 'http://anmtest.lingzhuyun.com/backlog'
  // home = 'http://fcctest.lingzhuyun.com/skypegmwcn'
  base = 'http://121.201.119.43:8007/account'
  organization = 'http://121.201.119.43:8007/organization'
  personalConsole = 'http://121.201.119.43:8007/personalConsole'
  enterpriseConsole = 'http://121.201.119.43:8007/enterpriseConsole'
  application = 'http://121.201.119.43:8007/application'
  product = 'http://121.201.119.43:8007/product' // 产品中心
  message = 'http://121.201.119.43:8007/message' // 消息中心
  user = 'http://121.201.119.43:8007/userCenterWeb' // 用户中心
  project = 'http://121.201.119.43:8007/project' // 项目中心
  attestation = 'http://121.201.119.43:8007/attestation' // 认证中心
  service = 'http://121.201.119.43:8007/serviceCenter' // 服务中心
  cooperation = 'http://121.201.119.43:8007/cooperation' // 合作中心
  safety = 'http://121.201.119.43:8007/safetyWeb' // 安全中心
  organizationManage = 'http://121.201.119.43:8007/organizationManageWeb' // 组织管理
  backlog = 'http://121.201.119.43:8007/backlog' // 待办
  home = 'http://121.201.119.43:8007/skypegmwcn'
  cooperationMarket = 'http://121.201.119.43:8007/cooperationMarket'
  serviceMarket = 'http://121.201.119.43:8007/serviceMarket'
  attestationMarket = 'http://121.201.119.43:8007/attestationMarket'
  applicationMarket = 'http://121.201.119.43:8007/applicationMarket'
} else if (target === 'production') {
  base = 'http://fcc.lingzhuyun.com/account' // 'http://192.168.1.225/account'
  organization = 'http://foc.lingzhuyun.com/organization' // 'http://192.168.1.225/organization'
  personalConsole = 'http://cpc.lingzhuyun.com/personalConsole' // 'http://192.168.1.225/personalConsole'
  enterpriseConsole = 'http://cbc.lingzhuyun.com/enterpriseConsole' // 'http://192.168.1.225/enterpriseConsole'
  application = 'http://fac.lingzhuyun.com/application' // 'http://192.168.1.225/application'
  product = 'http://fpc.lingzhuyun.com/product' // 产品中心
  message = 'http://fmc.lingzhuyun.com/message' // 消息中心
  user = 'http://fuc.lingzhuyun.com/userCenterWeb' // 用户中心
  project = 'http://fec.lingzhuyun.com/project' // 项目中心
  attestation = 'http://acm.lingzhuyun.com/attestation' // 认证中心
  service = 'http://fsc.lingzhuyun.com/serviceCenter' // 服务中心
  cooperation = 'http://fjc.lingzhuyun.com/cooperation' // 合作中心
  safety = 'http://fbc.lingzhuyun.com/safetyWeb' // 安全中心
  organizationManage = 'http://aom.lingzhuyun.com/organizationManageWeb' // 组织管理
  backlog = 'http://anm.lingzhuyun.com/backlog'
  home = 'http://lz.lingzhuyun.com/skypegmwcn'
  cooperationMarket = 'http://lz.lingzhuyun.com/cooperationMarket'
  serviceMarket = 'http://lz.lingzhuyun.com/serviceMarket'
  attestationMarket = 'http://lz.lingzhuyun.com/attestationMarket'
  applicationMarket = 'http://lz.lingzhuyun.com/applicationMarket'
} else if (target === 'dev:test') {
  base = 'http://fcctest.lingzhuyun.com/account' // 'http://192.168.1.225/account'
  organization = 'http://foctest.lingzhuyun.com/organization' // 'http://192.168.1.225/organization'
  personalConsole = 'http://cpctest.lingzhuyun.com/personalConsole' // 'http://192.168.1.225/personalConsole'
  enterpriseConsole = 'http://cbctest.lingzhuyun.com/enterpriseConsole' // 'http://192.168.1.225/enterpriseConsole'
  application = 'http://factest.lingzhuyun.com' // 'http://192.168.1.225/application'
  product = 'http://fpctest.lingzhuyun.com/product' // 产品中心
  message = 'http://fmctest.lingzhuyun.com/message' // 消息中心
  user = 'http://fuctest.lingzhuyun.com/user' // 用户中心
  project = 'http://fectest.lingzhuyun.com/project' // 项目中心
  attestation = 'http://acmtest.lingzhuyun.com/attestation' // 认证中心
  service = 'http://fsctest.lingzhuyun.com/service' // 服务中心
  cooperation = 'http://fjctest.lingzhuyun.com/cooperation' // 合作中心
  safety = 'http://fbctest.lingzhuyun.com/cooperation' // 安全中心
  organizationManage = 'http://aomtest.lingzhuyun.com/cooperation' // 组织管理
  backlog = 'http://anmtest.lingzhuyun.com/backlog'
  home = 'http://fcctest.lingzhuyun.com/skypegmwcn'
} else {
  base = 'http://192.168.1.224/account'
  organization = 'http://192.168.1.224/organization'
  personalConsole = 'http://192.168.1.224/personalConsole'
  enterpriseConsole = 'http://192.168.1.224/enterpriseConsole'
  application = 'http://192.168.1.224/application'
  product = 'http://192.168.1.224/product' // 产品中心
  message = 'http://192.168.1.224/message' // 消息中心
  user = 'http://192.168.1.224/userCenterWeb' // 用户中心
  project = 'http://192.168.1.224/project' // 项目中心
  attestation = 'http://192.168.1.224/attestation' // 认证中心
  service = 'http://192.168.1.224/serviceCenter' // 服务中心
  cooperation = 'http://192.168.1.224/cooperation' // 合作中心
  safety = 'http://192.168.1.224/safetyWeb' // 安全中心
  organizationManage = 'http://192.168.1.224/organizationManageWeb' // 组织管理
  backlog = 'http://192.168.1.224/backlog' // 待办
  home = 'http://192.168.1.224/skypegmwcn'
}

export default {
  base,
  organization,
  personalConsole,
  enterpriseConsole,
  application,
  product,
  message,
  user,
  project,
  attestation,
  service,
  cooperation,
  safety,
  organizationManage,
  backlog,
  home,
  cooperationMarket,
  serviceMarket,
  attestationMarket,
  applicationMarket
}



// WEBPACK FOOTER //
// ./src/config/env.js